import { storageUtils } from "./utils"

const SessionStorageServiceKeys: {
    UserLogout: () => string
    FakeParticipantTokenAccess: () => string
    FakeParticipantTokenRefresh: () => string
    FakeParticipantsFeatureEnabled: () => string
    UsedRegistrationKey: () => string
    ChatSocketToken(): string
    TabId(): string
    CoachingChatDraft(entityId: number): string
    CoachingChatSeedDrafts(entityId: number): string
} = {
    UserLogout: (): string => "userLoggedOut",
    FakeParticipantTokenAccess: (): string => "fakeParticipantTokenAccess",
    FakeParticipantTokenRefresh: (): string => "fakeParticipantTokenRefresh",
    FakeParticipantsFeatureEnabled: (): string => "fakeParticipantsFeatureEnabled",
    UsedRegistrationKey: (): string => "usedRegistrationKey",
    ChatSocketToken: (): string => "chatSocketToken",
    TabId: (): string => "tabId",
    CoachingChatDraft: (entityId: number): string => `coachingChatDraft:${entityId}`,
    CoachingChatSeedDrafts: (entityId: number): string => `coachingChatSeedDrafts:${entityId}`
}

class SessionStorageService extends Storage {
    static setItem<T>(key: ReturnType<() => keyof typeof SessionStorageServiceKeys>, value: T): void {
        sessionStorage.setItem(key, storageUtils.setStorageItemValue<T>(value))
    }

    static getItem<T>(key: ReturnType<() => keyof typeof SessionStorageServiceKeys>): T | null {
        return storageUtils.getStorageItemValue<T>(sessionStorage.getItem(key))
    }

    static removeItem(key: ReturnType<() => keyof typeof SessionStorageServiceKeys>): void {
        sessionStorage.removeItem(key)
    }

    static clear(): void {
        sessionStorage.clear()
    }
}

export { SessionStorageService, SessionStorageServiceKeys }
